import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 py-14 md:py-16">
          <div>
            <h3 className="font-heading text-2xl font-bold mb-4">SUGARGOO SPREADSHEET</h3>
            <p className="text-foreground-300 text-sm leading-relaxed max-w-xs">
              Your trusted resource for the latest Sugargoo spreadsheet guides, product lists, and
              shopping tutorials. Updated regularly to help you find the best deals.
            </p>
            <div className="flex items-center gap-3 mt-5">
              <span className="w-8 h-8 flex items-center justify-center rounded-full border border-foreground-600 text-foreground-300 hover:text-background-50 hover:border-background-50 transition-colors cursor-pointer">
                <i className="ri-twitter-x-line text-sm"></i>
              </span>
              <span className="w-8 h-8 flex items-center justify-center rounded-full border border-foreground-600 text-foreground-300 hover:text-background-50 hover:border-background-50 transition-colors cursor-pointer">
                <i className="ri-reddit-line text-sm"></i>
              </span>
              <span className="w-8 h-8 flex items-center justify-center rounded-full border border-foreground-600 text-foreground-300 hover:text-background-50 hover:border-background-50 transition-colors cursor-pointer">
                <i className="ri-discord-line text-sm"></i>
              </span>
            </div>
          </div>
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-foreground-400 mb-5">Quick Links</h4>
            <div className="space-y-3">
              <Link to="/" className="block text-sm text-foreground-300 hover:text-background-50 transition-colors">
                Home
              </Link>
              <Link to="/sugargoo-spreadsheet-guide" className="block text-sm text-foreground-300 hover:text-background-50 transition-colors">
                Complete Guide
              </Link>
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="block text-sm text-foreground-300 hover:text-background-50 transition-colors"
              >
                Main Website
              </a>
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="block text-sm text-foreground-300 hover:text-background-50 transition-colors"
              >
                Browse All Categories
              </a>
            </div>
          </div>
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-foreground-400 mb-5">Shopping Guides</h4>
            <div className="space-y-2.5">
              {articles.slice(0, 5).map((article) => (
                <Link
                  key={article.slug}
                  to={`/articles/${article.slug}`}
                  className="block text-sm text-foreground-300 hover:text-background-50 transition-colors"
                >
                  {article.title.length > 38 ? article.title.slice(0, 38) + '...' : article.title}
                </Link>
              ))}
            </div>
          </div>
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-foreground-400 mb-5">More Guides</h4>
            <div className="space-y-2.5 mb-5">
              {articles.slice(5).map((article) => (
                <Link
                  key={article.slug}
                  to={`/articles/${article.slug}`}
                  className="block text-sm text-foreground-300 hover:text-background-50 transition-colors"
                >
                  {article.title.length > 38 ? article.title.slice(0, 38) + '...' : article.title}
                </Link>
              ))}
            </div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-foreground-400 mb-3">Disclaimer</h4>
            <p className="text-sm text-foreground-300 leading-relaxed">
              This site is an independent resource and is not affiliated with Sugargoo. We do not sell products.
              Users should verify items before purchasing.
            </p>
          </div>
        </div>
        <div className="border-t border-foreground-800 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; 2026 Sugargoo Spreadsheet Guide. All rights reserved.
          </p>
          <div className="flex items-center gap-5 flex-wrap justify-center">
            <Link to="/" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors">
              Home
            </Link>
            <Link to="/sugargoo-spreadsheet-guide" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors">
              Guide
            </Link>
            <span className="text-xs text-foreground-500">Last updated: June 2026</span>
          </div>
        </div>
      </div>
    </footer>
  );
}